export const GET_PARTICIPANTS = "GET_PARTICIPANTS";
export const CLEAR_PARTICIPANTS = "CLEAR_PARTICIPANTS";
export const UPDATE_PARTICIPANT_STATUS = "UPDATE_PARTICIPANT_STATUS";
export const GET_ORGANISATION_DATA_FOR_PARTICIPANT = "GET_ORGANISATION_DATA_FOR_PARTICIPANT";
export const CLEAR_ORGANISATION_DATA_FOR_PARTICIPANT = "CLEAR_ORGANISATION_DATA_FOR_PARTICIPANT";
export const GET_ASSESSMENT_CONFIG = "GET_ASSESSMENT_CONFIG";
export const CLEAR_ASSESSMENT_CONFIG = "CLEAR_ASSESSMENT_CONFIG";
export const GET_ASSESSMENT_PROGRAM_SETTINGS = "GET_ASSESSMENT_PROGRAM_SETTINGS";
export const CLEAR_ASSESSMENT_PROGRAM_SETTINGS = "CLEAR_ASSESSMENT_PROGRAM_SETTINGS";
export const GET_PARTICIPANT_DETAILS_SUCCESS = "GET_PARTICIPANT_DETAILS_SUCCESS";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const CLEAR_DASHBOARD_DATA = "CLEAR_DASHBOARD_DATA";
export const GET_ADJUSTED_PROGRAM_SETTING = "GET_ADJUSTED_PROGRAM_SETTING";
export const CLEAR_ADJUSTED_PROGRAM_SETTING = "CLEAR_ADJUSTED_PROGRAM_SETTING";
export const GET_PARTICIPANT_SESSION_VALUES = "GET_PARTICIPANT_SESSION_VALUES";
export const CLEAR_APPOINTMENT_SETTINGS = "CLEAR_APPOINTMENT_SETTINGS";
export const GET_BELONGING_GROUPS = "GET_BELONGING_GROUPS";
export const CLEAR_BELONGING_GROUPS = "CLEAR_BELONGING_GROUPS";
export const GET_GROUPS = "GET_GROUPS";
export const GET_ALTERNATIVE_PROJECTS = "GET_ALTERNATIVE_PROJECTS";
export const CLEAR_ALTERNATIVE_PROJECTS = "CLEAR_ALTERNATIVE_PROJECTS";
export const GET_PROJECT_SETTINGS = "GET_PROJECT_SETTINGS";
export const CLEAR_PROJECT_SETTINGS = "CLEAR_PROJECT_SETTINGS";
